interface IGetImageSizeAndProportion {
  width: number;
  height: number;
  maxWidth: number;
  maxHeight: number;
}

export const getImageSizeAndProportion = ({
  width,
  height,
  maxHeight,
  maxWidth,
}: IGetImageSizeAndProportion): any => {
  const ratio = Math.min(maxWidth / width, maxHeight / height);
  return {
    width: width * ratio < width ? width * ratio : width,
    height: height * ratio < height ? height * ratio : height,
  };
};
